import { render, staticRenderFns } from "./AboutCourier.vue?vue&type=template&id=0f3060ce&scoped=true&"
import script from "./AboutCourier.vue?vue&type=script&async=true&lang=js&"
export * from "./AboutCourier.vue?vue&type=script&async=true&lang=js&"
import style0 from "./AboutCourier.vue?vue&type=style&index=0&id=0f3060ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3060ce",
  null
  
)

export default component.exports